import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { SignalrHubService } from './../../../services/signalr-hub.service';
import { Observable } from 'rxjs';
import { AllotmentService } from './../../../services/allotment.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allotment-process',
  templateUrl: './allotment-process.component.html',
  styleUrls: ['./allotment-process.component.css']
})
export class AllotmentProcessComponent implements OnInit {

  message$: Observable<string>;
  loading: boolean = false;
  designations: IKeyValuePair[];
  ids: number[] = [];
  selectedPhase: string = '';

  constructor(
    private allotmentService: AllotmentService,
    private commonService: CommonService,
    private signalrHubService: SignalrHubService) { }

  ngOnInit(): void {
    this.bindDropDown();
    this.message$ = this.signalrHubService.message$;
    this.signalrHubService.startConnection();         
  }  

  bindDropDown() {
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {     
        this.designations = response;                        
      }           
    });
  }

  generateEmployeeMerit() {                                                                                                      
    this.loading = true;

    this.allotmentService.generateEmployeeMerit(this.ids).subscribe(response => {
      if (response) {
        this.signalrHubService.changeMessage(response.message);
      }
    },
      (error) => console.log(error),
      () => this.loading = false);
  }

  processAllotment() {
    this.loading = true;

    this.allotmentService.processAllotment(this.ids).subscribe(response => {
      if (response) {
        this.signalrHubService.changeMessage(response.message);
      }
    },
      (error) => console.log(error),
      () => this.loading = false);    
  }
  downloadPdf() {
    this.loading = true;
  
    this.allotmentService.downloadPdf().subscribe(
      (response: Blob) => {
        if (response) {
          const blob = new Blob([response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'EmployeeMeritList.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      },
      (error) => {
        console.error('PDF Download Error:', error);
      },
      () => this.loading = false
    );
  }
  
  
  onPhaseChange(event: any) {
    this.selectedPhase = event.target.value;
  }
  export() {
   this.loading = true;

   this.allotmentService.export(this.ids,this.selectedPhase).subscribe(response => {
     if (response) {
       const blob = new Blob([response], { type: 'application/octet-stream' });
       var downloadURL = window.URL.createObjectURL(response);
       var link = document.createElement('a');
       link.href = downloadURL;
       link.download = "employee-list.xlsx";
       link.click();
     }
   },
     (error) => console.log(error),
     () => this.loading = false);
  }



  changeDesignation(checked, item) {

    if (checked) {
      let id = this.ids ? this.ids.find(x => x == item) : null;
      if (!id)
        this.ids.push(item);
    }
    else {
      this.ids = this.ids.filter(x => x != item);
    }

  }

  isDesignationChecked(item) {
    var id = this.ids ? this.ids.find(x => x == item) : null;
    if (!id)
      return false;
    else
      return true;
  }
}
